import {
  CreditorConnectionModel,
  PayoutCreditFacilityModel,
  CreateNewPayoutCreditFacilityModel,
  UpdatePayoutCreditFacilityModel,
} from '../redux/types';
import useFetchClient from "./useFetchClient";
import { useAppDispatch } from "../redux/hooks";
import { restConfig } from "../authConfig";
import { 
  payoutCreditFacilityCreateFailure, 
  payoutCreditFacilityCreated, 
  payoutCreditFacilityBankAccountSet,
  payoutCreditFacilityBankAccountSetFailure,
  payoutCreditFacilityCreditSpaceWarningSilenceFailure, 
  payoutCreditFacilityCreditSpaceWarningSilenced, 
  payoutCreditFacilityCreditorAddFailure, 
  payoutCreditFacilityCreditorAdded, 
  payoutCreditFacilityCreditorDeleteFailure, 
  payoutCreditFacilityCreditorDeleted, 
  payoutCreditFacilityDetailsFetchFailure, 
  payoutCreditFacilityDetailsFetched, 
  payoutCreditFacilityUpdateFailure, 
  payoutCreditFacilityUpdated, 
  loading
} from '../redux/slices/payoutCreditFacilitySlice';

const usePayoutCreditFacilityActions = () => {
  const fetchClient = useFetchClient()
  const dispatch = useAppDispatch()

  const getPayoutCreditFacilityDetails = (payoutCreditFacilityId: string) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + `/${payoutCreditFacilityId}`

    return fetchClient.get(url)
      .then(response => {
          dispatch(payoutCreditFacilityDetailsFetched(response.data as PayoutCreditFacilityModel))
      })
      .catch(error => {
          console.log('getPayoutCreditFacilityDetails error:', error)
          dispatch(payoutCreditFacilityDetailsFetchFailure(error))
      })
  }

  const createPayoutCreditFacility = (facility: CreateNewPayoutCreditFacilityModel) => {
    dispatch(loading())
    return fetchClient.post(restConfig.routes.payoutCreditFacilities, facility)
      .then(response => {
          dispatch(payoutCreditFacilityCreated(response.data as string))
      })
      .catch(error => {
          console.log('createPayoutCreditFacility error:', error)
          dispatch(payoutCreditFacilityCreateFailure(error))
      })
  }

  const updatePayoutCreditFacility = (facilityId: string, updateModel: UpdatePayoutCreditFacilityModel) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + '/' + facilityId

    return fetchClient.post(url, updateModel)
      .then(response => {
          dispatch(payoutCreditFacilityUpdated(response.data as PayoutCreditFacilityModel))
      })
      .catch(error => {
          console.log('updatePayoutCreditFacility error:', error)
          dispatch(payoutCreditFacilityUpdateFailure(error))
      })
  }

  const setRepaymentBankAccount = (facilityId: string, bankAccountId: string) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + `/${facilityId}/bankaccount`

    return fetchClient.post(url, { bankAccountId })
      .then(response => {
          dispatch(payoutCreditFacilityBankAccountSet(response.data as PayoutCreditFacilityModel))
      })
      .catch(error => {
          console.log('setRepaymentBankAccount error:', error)
          dispatch(payoutCreditFacilityBankAccountSetFailure(error))
      })
  }

  const silenceCreditSpaceWarning = (facilityId: string, days: number) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + `/${facilityId}/creditspacewarning`

    return fetchClient.post(url, { days })
      .then(response => {
          dispatch(payoutCreditFacilityCreditSpaceWarningSilenced(response.data as PayoutCreditFacilityModel))
      })
      .catch(error => {
          console.log('silenceCreditSpaceWarning error:', error)
          dispatch(payoutCreditFacilityCreditSpaceWarningSilenceFailure(error))
      })
  }

  const addCreditor = (facilityId: string, creditor: CreditorConnectionModel) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + `/${facilityId}/creditors`

    return fetchClient.post(url, { creditorId: creditor.id, priority: creditor.priority})
      .then(response => {
          dispatch(payoutCreditFacilityCreditorAdded(creditor))
      })
      .catch(error => {
          console.log('addCreditor error:', error)
          dispatch(payoutCreditFacilityCreditorAddFailure(error))
      })
  }

  const deleteCreditor = (facilityId: string, creditorId: string) => {
    dispatch(loading())
    const url = restConfig.routes.payoutCreditFacilities + `/${facilityId}/creditors/${creditorId}`

    return fetchClient.delete(url)
      .then(response => {
          dispatch(payoutCreditFacilityCreditorDeleted(creditorId))
      })
      .catch(error => {
          console.log('deleteCreditor error:', error)
          dispatch(payoutCreditFacilityCreditorDeleteFailure(error))
      })
  }

  return {
    getPayoutCreditFacilityDetails,
    createPayoutCreditFacility,
    updatePayoutCreditFacility,
    setRepaymentBankAccount,
    silenceCreditSpaceWarning,
    addCreditor,
    deleteCreditor
  }
}

export default usePayoutCreditFacilityActions
